import BHowResults from './BHowResults'

export default BHowResults
